import React from "react";
import { cn } from "../../../lib/utils";
import { FIELD, FIELD_INVALID } from "./classes";

/** Multi-line field; the large corner radius of the wireframes' note and body boxes. */
const CrmTextarea = React.forwardRef(function CrmTextarea({ className, invalid, rows = 3, ...rest }, ref) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cn(FIELD, "resize-y", invalid && FIELD_INVALID, className)}
      {...rest}
    />
  );
});

export default CrmTextarea;
